var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.51416 12.5137H12.5138",
    stroke: "#6B7280",
    strokeWidth: 1.02854,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1139 4.71436H7.71401C6.22485 4.71436 5.91406 5.02515 5.91406 6.51431V12.5141H11.9139V6.51431C11.9139 5.02515 11.6031 4.71436 10.1139 4.71436Z",
    stroke: "#6B7280",
    strokeWidth: 1.02854,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31406 12.5138H1.11426V2.31411C1.11426 0.824951 1.42505 0.51416 2.91421 0.51416H6.51411C8.00327 0.51416 8.31406 0.824951 8.31406 2.31411V4.71404",
    stroke: "#6B7280",
    strokeWidth: 1.02854,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.11426 2.91479H2.91421M1.11426 5.31473H2.91421M1.11426 7.71466H2.91421M8.31406 7.11468H9.51402M8.31406 8.91463H9.51402",
    stroke: "#6B7280",
    strokeWidth: 1.02854,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91406 12.5141V10.7141",
    stroke: "#6B7280",
    strokeWidth: 1.02854,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingIcon);
export default __webpack_public_path__ + "static/media/building-icon.8220a72666d49952768e5bd2fb8e4a72.svg";
export { ForwardRef as ReactComponent };